import { j as e } from "./atoms-v218.js";
import { forwardRef as x } from "react";
import { SelectorButtonContainer as j, SelectorButtonInterior as y, SelectorIcon as R, Label as S, Value as B } from "./atoms-v2732.js";
const L = x(
  ({
    className: $,
    colorTheme: t = "light",
    isDisabled: r = !1,
    isRounded: d = !1,
    label: n,
    leftIcon: o,
    onClick: a,
    rightIcon: s,
    showLabel: m = !0,
    size: l = "default",
    value: u
  }, c) => {
    const f = (i) => i ? typeof i == "string" ? /* @__PURE__ */ e.jsx(R, { $colorTheme: t, $isDisabled: r, name: i, size: "medium" }) : i : null, p = () => !n || !m ? null : typeof n == "string" ? /* @__PURE__ */ e.jsx(S, { $colorTheme: t, $isDisabled: r, $size: l, children: n }) : n, h = () => u ? typeof u == "string" ? /* @__PURE__ */ e.jsx(B, { $colorTheme: t, $isDisabled: r, $size: l, children: u }) : u : null;
    return /* @__PURE__ */ e.jsxs(
      j,
      {
        $colorTheme: t,
        $hasLeftIcon: !!o,
        $hasRightIcon: !!s,
        $isDisabled: r,
        $isRounded: d,
        className: $,
        disabled: r,
        onClick: a,
        ref: c,
        type: "button",
        children: [
          o ? f(o) : null,
          /* @__PURE__ */ e.jsxs(y, { $hasLeftIcon: !!o, $hasRightIcon: !!s, $size: l, children: [
            p(),
            h()
          ] }),
          s ? f(s) : null
        ]
      }
    );
  }
);
L.displayName = "SelectorButton";
export {
  L as SelectorButton
};
